<template>
	<div class="time-slider mx-2" style="width:100%;">

		<div class="mx-4">

			<vue-slider
				ref="slider"
				width="100%"
				tooltip="hover"
				:disabled="false"
				tooltip-dir="bottom"
				:min="-6000"
				:max="currentYear()"
				:interval="1"
        :piecewise="false"
				:piecewiseLabel="false"
				:process-style="processStyle"
        :tooltip-style="tooltipStyle"
        :slider-style="sliderStyle"
				v-model="dates"
				@drag-end="timeChanged()"
				@drag-start="isDragging = true"
			>
				<template slot="label" slot-scope="{ label }">
			  	<span :class="['custom-label']" :style="formatStyle(label)" v-if="label % 2000 === 0">
			    	{{ label }}
			  	</span>
		    </template>
        <template slot="piecewise" slot-scope="{ label, index, active, first, last }">
        </template>

			</vue-slider>
		</div>

    <div class="mx-4 time-slider-labels text-center">
      <div style="position:relative;width:100%">
        <div v-for="label in labels" :style="getLabelStyle(label)">
          {{label.label}}
        </div>
      </div>
    </div>
	</div>

</template>

<script>
import vueSlider from 'vue-slider-component'
import moment from 'moment'

import { interval as intervalObs } from 'rxjs'
import { first as firstObs, map as mapObs, skipWhile, toPromise } from 'rxjs/operators'

export default {
  components: {
  	vueSlider
  },
  name: 'time-slider',
  watch: {
    dates () {
      if (this.isDragging) return;
      this.timeChanged()
    }
  },
  methods: {
    beforeInit () {
      return intervalObs(100)
        .pipe(skipWhile(() => !this.$parent.$sources))
        .pipe(skipWhile(() => !this.allSourcesLoaded()))
        .pipe(firstObs())
        .pipe(mapObs(() => this))
        .toPromise(Promise)
    },
    allSourcesLoaded() {
        // Something loaded?
        if (this.$sourcesLoaded <= 0) return False
        // Check their status
        if (this.$sourcesAdded > this.$sourcesLoaded) {
            return false
        }
        // All good
        return true
    },
    formatStyle(label) {
    	var marginLength = String(label).length > 1 ? String(label).length * -3 : 0;
    	return 'margin-left:'+marginLength+'px';
    },
    timeChanged() {
    	this.isDragging = false;
    	this.emitCurrentValue();

    	for (var i = 0; i < this.$sources.length; i++) {
    		if (this.$sources[i].timeEnabled) {
    			this.$sources[i].timeChanged(this.dates[0], this.dates[1]);
    		}
    	}

    },
    emitCurrentValue() {
    	this.$emit('time-changed', this.dates[0] + ' ' + this.dates[1]);
    },
    currentYear() {
      return parseInt(moment().format('YYYY'));
    },
    calcLabelIntv(){
      let start = Math.floor(this.max/this.interval) * this.interval
      for (var i = start; i >= this.min; i-=this.interval) {
        this.calcLabelPct(i)
      }
    },
    calcLabelPct(i){
      let pct = ((i - this.min)/(this.max-this.min))*100
      this.labels.push({"label":i,"pct":pct})
    },
    getLabelStyle(label){
      return "position:absolute;left:"+label.pct+"%;-webkit-transform: translate(-50%, 0);"
    },
    getGradient(year){
      var cyan = (2000/(year+6000))*100
      var blue = (5000/(year+6000))*100
      var green = (6400/(year+6000))*100
      var orange = green+0.01
      var red = (7000/(year+6000))*100
      var red2 = (7500/(year+6000))*100
      return "-webkit-linear-gradient(left, #60ffff, #60ffff "+cyan+"%, #0002fb "+blue+"%, #6beb00 "+green+"%, #ff8100 "+orange+"%, #ff1400 "+red+"%, #ff1400 "+red2+"%, #ff6f6f 100%)"
    }
  },
  data () {
    return {
    	isDragging: false,
      dates:[-6000,2000],
    	processStyle: {
    		"background-color": "rgba(100,100,100,0)"
    	},
      sliderStyle: [
        {
          "backgroundColor": "#5E9732"
        },
        {
          "backgroundColor": "#f05b72"
        }
      ],
      tooltipStyle: [
        {
          "backgroundColor": "#5E9732",
          "borderColor": "#5E9732"
        },
        {
          "backgroundColor": "#f05b72",
          "borderColor": "#f05b72"
        }
      ],
      max: null,
      min: -6000,
      interval: 1000,
      labels:[]
    }
  },
  created() {

  	Object.defineProperties(this, {
  		$sources: {
  			enumerable: true,
  			get: () => this.$parent.$sources
          },
      $sourcesAdded: {
  			enumerable: true,
  			get: () => this.$parent.$sourcesAdded
          },
      $sourcesLoaded: {
  			enumerable: true,
  			get: () => this.$parent.$sourcesLoaded
  		    }
  	})

  },
  mounted () {

    this.max = this.currentYear()
    this.dates[1] = this.max
    this.calcLabelIntv()
    this.beforeInit().then(() => {
      this.timeChanged()
    })
    document.querySelector(".vue-slider").style.background = this.getGradient(this.max)
  	// console.log("Mounted the time slider component")
  }
}
</script>

<style lang="css">
  
</style>



// WEBPACK FOOTER //
// resources/js/map/MapComponents/Toolbar/TimeSlider.vue